import { mapApiTeamToDetailView } from "../../../../../utils/teamMappers";

export function buildTeamDetailView(team) {
  return mapApiTeamToDetailView(team);
}
